import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import MarqueeImport from "react-fast-marquee";
import { RenmoneyLogo, FutureAfrica, AbiaLogo, CcInterior, PlaudeLogo, AbiaGovt } from "assets/website";
import {
  pricingPartner1,
  pricingPartner2,
  pricingPartner3,
  pricingPartner4,
  pricingPartner5,
} from "assets/images";

// Handle CommonJS/ESM interop
const Marquee = (MarqueeImport as any).default || MarqueeImport;

const partnerLogos = [
  { component: RenmoneyLogo, name: "Renmoney" },
  { component: FutureAfrica, name: "Future Africa" },
  { component: AbiaLogo, name: "Abia Leadership Academy" },
  { component: CcInterior, name: "CC Interiors" },
  { component: PlaudeLogo, name: "Plaude" },
  { component: AbiaGovt, name: "Abia Government" },
];

const pricingPartnerImages = [
  { src: pricingPartner1, name: "Partner 1" },
  { src: pricingPartner2, name: "Partner 2" },
  { src: pricingPartner3, name: "Partner 3" },
  { src: pricingPartner4, name: "Partner 4" },
  { src: pricingPartner5, name: "Partner 5" },
];

interface MobilePartnersProps {
  onPricing?: boolean;
}

const MobilePartners = ({ onPricing }: MobilePartnersProps) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  if (!isMobile) return null;

  return (
    <section className={`py-12 overflow-hidden ${onPricing ? "bg-[#EFF4FA]" : "bg-white"}`}>
      {!onPricing && <div className="container mx-auto px-4 !mb-8">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center text-[#475467] text-lg font-medium"
        >
          Trusted by forward-thinking teams.
        </motion.p>
      </div>}

      <Marquee speed={40} gradient={false}>
        {
          // onPricing
          //   ? pricingPartnerImages.map((partner, index) => (
          //       <div key={index} className="flex items-center justify-center mx-6">
          //         <img
          //           src={partner.src}
          //           alt={partner.name}
          //           className="h-7 w-auto object-contain"
          //         />
          //       </div>
          //     ))
          //   : 
          partnerLogos.map((partner, index) => {
            const Logo = partner.component;
            return (
              <div key={index} className="flex items-center justify-center mx-6">
                <Logo className="h-7 w-auto" />
              </div>
            );
          })}
      </Marquee>
    </section>
  );
};

export { MobilePartners };
